export default "__VITE_ASSET__O4U_3T9a__"